/**
 * Slide Cart Subscription Integration
 * Automatically applies subscriptions when adding products to cart
 */

(function() {
  var pendingSubscription = null;

  // Helper function to check if a form is from a product card
  function isProductCardForm(form) {
    if (!form) return false;
    var productCard = form.closest('.product-card');
    var productForm = form.closest('product-form');
    return productCard || (productForm && productForm.hasAttribute('data-product-url'));
  }

  // Intercept form submissions to remove selling_plan from product card forms
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    
    // If this is from a product card, remove any selling_plan inputs
    if (isProductCardForm(form)) {
      // Remove any hidden selling_plan inputs
      var sellingPlanInputs = form.querySelectorAll('input[name="selling_plan"], input[name="selling-plan"]');
      sellingPlanInputs.forEach(function(input) {
        input.remove();
      });
    }
  }, true); // Use capture phase to intercept before other handlers

  // Intercept fetch requests to /cart/add.js to remove selling_plan for product cards
  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    
    // Check if this is a cart add request
    if (typeof url === 'string' && url.includes('/cart/add.js')) {
      var body = args[1] && args[1].body;
      var shouldRemoveSellingPlan = false;
      
      // Check if this request is from a product card
      // Product cards typically have section-id that's not from main product page
      // Header product cards have section-id='header'
      // Other product cards might have different section-ids
      // Main product page typically doesn't have section-id in the form data
      
      if (body instanceof FormData) {
        var sectionId = body.get('section-id');
        // If section-id exists and is 'header', it's definitely a product card
        // Also check if there's a product-form with data-product-url attribute
        if (sectionId === 'header') {
          shouldRemoveSellingPlan = true;
        } else if (sectionId) {
          // Check if this section-id belongs to a product card
          // Look for the form in the DOM
          var formId = 'product-form-' + sectionId;
          var form = document.getElementById(formId);
          if (form && isProductCardForm(form)) {
            shouldRemoveSellingPlan = true;
          }
        }
        
        if (shouldRemoveSellingPlan) {
          body.delete('selling_plan');
          body.delete('selling-plan');
        }
      } else if (body instanceof URLSearchParams) {
        var sectionId = body.get('section-id');
        if (sectionId === 'header') {
          shouldRemoveSellingPlan = true;
        } else if (sectionId) {
          var formId = 'product-form-' + sectionId;
          var form = document.getElementById(formId);
          if (form && isProductCardForm(form)) {
            shouldRemoveSellingPlan = true;
          }
        }
        
        if (shouldRemoveSellingPlan) {
          body.delete('selling_plan');
          body.delete('selling-plan');
        }
      } else if (typeof body === 'string') {
        // Handle string body (form-encoded or JSON)
        try {
          // Try to parse as URLSearchParams (form-encoded)
          var params = new URLSearchParams(body);
          var sectionId = params.get('section-id');
          if (sectionId === 'header') {
            shouldRemoveSellingPlan = true;
          } else if (sectionId) {
            var formId = 'product-form-' + sectionId;
            var form = document.getElementById(formId);
            if (form && isProductCardForm(form)) {
              shouldRemoveSellingPlan = true;
            }
          }
          
          if (shouldRemoveSellingPlan) {
            params.delete('selling_plan');
            params.delete('selling-plan');
            args[1].body = params.toString();
          }
        } catch (e) {
          // Not URLSearchParams, might be JSON
          try {
            var jsonData = JSON.parse(body);
            var sectionId = jsonData['section-id'];
            if (sectionId === 'header') {
              shouldRemoveSellingPlan = true;
            } else if (sectionId) {
              var formId = 'product-form-' + sectionId;
              var form = document.getElementById(formId);
              if (form && isProductCardForm(form)) {
                shouldRemoveSellingPlan = true;
              }
            }
            
            if (shouldRemoveSellingPlan) {
              delete jsonData.selling_plan;
              delete jsonData['selling-plan'];
              args[1].body = JSON.stringify(jsonData);
            }
          } catch (e2) {
            // Not JSON either, leave as is
          }
        }
      }
    }
    
    return originalFetch.apply(this, args);
  };

  // Capture subscription choice when Add to Cart button is clicked
  document.addEventListener('click', function(e) {
    var button = e.target.closest('button[type="submit"][name="add"]');
    if (!button) return;

    // Check if this button/form is from a product card
    // Product cards should ALWAYS add as one-time purchases, never subscriptions
    var form = button.closest('form');
    var productCard = button.closest('.product-card') || form?.closest('.product-card');
    var productForm = button.closest('product-form');
    
    // If this is from a product card, skip subscription logic entirely
    if (productCard || (productForm && productForm.hasAttribute('data-product-url'))) {
      pendingSubscription = null;
      return; // Exit early - product cards are always one-time purchases
    }

    // Only check for subscription widgets if NOT from a product card
    // Scope the search to the form's context to avoid picking up unrelated widgets
    var formContainer = form ? form.closest('main, .main-content, [role="main"]') : null;
    var subscriptionWidget = formContainer 
      ? formContainer.querySelector('.subscription-widget')
      : document.querySelector('.subscription-widget');
    
    // Also check if we're on the coffee club page (has recharge-bundles container)
    // If so, skip subscription logic as it's likely picking up ReCharge bundle selling plans
    var isCoffeeClubPage = document.getElementById('recharge-bundles') !== null;
    if (isCoffeeClubPage && !formContainer) {
      pendingSubscription = null;
      return;
    }
    
    var isSubscription = subscriptionWidget && subscriptionWidget.dataset.subscribe === 'true';

    if (isSubscription) {
      // Look for subscription select within the same context as the widget
      var selectEl = subscriptionWidget 
        ? subscriptionWidget.querySelector('.subscribe-and-save-plan__select')
        : document.querySelector('.subscribe-and-save-plan__select');
      
      // Exclude ReCharge bundle selling plan select (has id="selling-plan-list")
      if (selectEl && selectEl.id === 'selling-plan-list') {
        pendingSubscription = null;
        return;
      }
      
      var sellingPlan = selectEl ? selectEl.value : null;
      
      if (sellingPlan) {
        var formData = new FormData(form);
        var variantId = formData.get('id');

        pendingSubscription = {
          variantId: variantId,
          sellingPlan: sellingPlan
        };
      }
    } else {
      pendingSubscription = null;
    }
  }, true);

  // Use Slide Cart's official API callback
  window.SLIDECART_ADD_TO_CART = function(data) {
    // Skip processing if Recharge bundle is adding items
    if (window.RECHARGE_BUNDLE_ADDING) {
      console.log('Skipping slide cart processing - Recharge bundle is adding items');
      return;
    }
    
    if (!pendingSubscription) return;

    var addedId = data.id;

    if (addedId.toString() !== pendingSubscription.variantId.toString()) {
      return;
    }

    // Wait for item to be fully added to cart
    setTimeout(function() {
      fetch('/cart.js')
        .then(function(response) { 
          return response.json(); 
        })
        .then(function(cartData) {
          var lineIndex = -1;
          for (var i = 0; i < cartData.items.length; i++) {
            if (cartData.items[i].variant_id.toString() === addedId.toString() && !cartData.items[i].selling_plan_allocation) {
              lineIndex = i;
              break;
            }
          }

          if (lineIndex === -1) {
            pendingSubscription = null;
            return Promise.resolve(null);
          }

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: lineIndex + 1,
              quantity: cartData.items[lineIndex].quantity,
              selling_plan: parseInt(pendingSubscription.sellingPlan, 10)
            })
          });
        })
        .then(function(changeResponse) {
          if (!changeResponse) return;
          
          if (changeResponse.ok) {
            // Update Slide Cart to show subscription
            window.SLIDECART_UPDATE(function() {
              console.log('Subscription applied successfully');
            });
          }
          pendingSubscription = null;
        })
        .catch(function(error) {
          console.error('Error applying subscription:', error);
          pendingSubscription = null;
        });
    }, 500);
  };
})();

